import React from 'react'
import { connect } from 'react-redux'

import BasePureComponent from 'utils/BasePureComponent'
import RetractablePanel from 'components/RetractablePanel'

import './style.scss'


export class AccountSummary extends BasePureComponent {

  _renderData() {
    var total_vehicles = !!this.props.vehicles ? this.props.vehicles.length : 0
    return (
      <div className="AccountSummary__plain">
        <RetractablePanel
                ref={(panel) => this.panel = panel}
                name="Resumen de cuenta"
                isToggle={true}
        >
          <div className="DataRow">
            <strong>Unidades activas:</strong>
            <span>{ total_vehicles }</span>
          </div>
          <div className="DataRow">
            <strong>Tipo de cliente:</strong>
            <span>{ this.props.client.client_type }</span>
          </div>
        </RetractablePanel>
        <br></br>
      </div>
    )
  }

  render() {
    return (
      <div id="AccountSummary">
        { this._renderData() }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.clientDetail.get('user').toJS(),
    client: state.clientDetail.get('client').toJS(),
    vehicles: state.clientDetail.get('vehicles').toJS(),
  }
}

export default connect(mapStateToProps)(AccountSummary)



// WEBPACK FOOTER //
// ./src/scenes/ClientDetail/components/AccountSummary/index.js